import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DefaultModal from 'Modals/DefaultModal';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import PDFIcon from 'Icons/PDFIcon';
import bemit from 'Functions/bemit';
import { front_urls, action, URL } from 'Shared/Routes';
export default class AdminPackOrderIndexRow extends Component {
  state = {
    loading: false
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const link = /*#__PURE__*/React.createElement(Link, {
      className: "u-link-only",
      href: URL('AdminPackOrdersIndexDashboard', front_urls) + '/' + data.id
    }, "Fiche du pack");
    let output = /*#__PURE__*/React.createElement("div", {
      className: 'c-dashboard__row '
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrderIndex-date"
    }, data.code, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrderIndex-hours"
    }, data._packorder?.company?.name, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell PackOrderIndex-amount"
    }, moment(data?._packorder?.created_at).format("DD/MM/YYYY"), link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrderIndex-login"
    }, moment(data?._packorder?.payment_capture?.Date).format("DD/MM/YYYY"), link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrderIndex-login"
    }, data.credit_amount, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrderIndex-login"
    }, data.remaining_credit, link), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell CustomerPackOrderIndex-login"
    }, data.expiration_date ? moment(data.expiration_date).format('DD/MM/YYYY') : 'Pack en attente'));
    return output;
  }
}
